import { useAtom } from 'jotai';
import { LottieRefCurrentProps } from 'lottie-react';
import { forwardRef } from 'react';
import { ContinueTotalBlock, ListActions } from 'src/components';
import { getCartIdAtom } from 'src/store';
import type { CartApprovalStatus, CartGetItem } from 'src/types';

type Props = {
  handleContinue?: (skipApproval: boolean) => void;
  handleApproveOrReject?: (response: 'approve' | 'reject') => void;
  ccy: string;
  ccyS: string;
  cartPrice: string;
  totalQty: number;
  cartTitle: string | undefined;
  cartItems: CartGetItem[];
  cartTimestamp: number;
  cartStore: string | undefined;
  isLoading: boolean;
  page: 'get' | 'embed' | 'review';
  requestedByEmail: string;
  orgApprovalStatus?: CartApprovalStatus;
};

export const GetReviewFooter = forwardRef<LottieRefCurrentProps, Props>(
  (
    {
      handleContinue,
      handleApproveOrReject,
      ccyS,
      ccy,
      cartPrice,
      totalQty,
      cartTitle,
      cartItems,
      cartTimestamp,
      cartStore,
      isLoading,
      page,
      requestedByEmail,
      orgApprovalStatus,
    },
    ref,
  ) => {
    const [cartId] = useAtom(getCartIdAtom);

    return (
      <div className='mx-auto flex w-full max-w-[1440px] flex-row flex-wrap items-end justify-between gap-y-8 px-6 pb-0 pt-8 xs:gap-y-10 smMed:gap-x-4 sm:gap-y-8 md:px-10 medLg:flex-nowrap medLg:items-start lg:px-12'>
        {page === 'get' && (
          <ListActions
            cartId={cartId}
            cartCCY={ccy}
            cartCCYS={ccyS}
            cartTitle={cartTitle}
            cartItems={cartItems}
            cartTimestamp={cartTimestamp}
            cartStore={cartStore}
            isLoading={isLoading}
          />
        )}
        <ContinueTotalBlock
          ref={ref}
          handleContinue={handleContinue}
          handleApproveOrReject={handleApproveOrReject}
          totalPrice={cartPrice}
          totalQty={totalQty}
          forReviewFooter={true}
          isLoading={isLoading}
          page={page}
          requestedByEmail={requestedByEmail}
          orgApprovalStatus={orgApprovalStatus}
          cartId={cartId}
        />
      </div>
    );
  },
);
